import { IconButton, Input, InputAdornment } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setDefectFilterKey, setSelection } from '../../store/actions';
import SelectDialog from '../SelectDialog';
import DefectTable from './defect';
import SelectedChip from './selected';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  addIcon: {
    marginRight: theme.spacing(1)
  },
  done: {
    textDecoration: 'line-through',
    color: theme.palette.text.secondary
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  }
}));

function SelectDefect(props, className) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');

  return (
    <SelectDialog
      open={props.open}
      title={props.title}
      onClose={props.onClose}
      onEntering={() => props.setDefectFilterKey('')}
      ReceiptNo={props.ReceiptNo}
      actions
      SearchField={
        <div className={classes.fields}>
          <Input
            onChange={event => props.setDefectFilterKey(event.target.value)}
            value={props.defects.filterKey} 
            endAdornment={
              <InputAdornment position="end">
                <IconButton edge="end">
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            }
            aria-describedby="standard-weight-helper-text"
            placeholder={t('HizmetArama')}
          />
        </div>
      }
      SelectedItems={<SelectedChip />}
    >
      <DefectTable ReceiptNo={props.ReceiptNo} />
    </SelectDialog>
  );
}

const mapStateToProps = state => ({
  defects: state.defectReducer
});

const mapDispatchToProps = {
  setSelection,
  setDefectFilterKey
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectDefect);
